import React, { useEffect, useState } from 'react'
import MultiStepProgress from '../common/multiStepProgress'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import mobileView from '../../utils/mobile.utils'
import InvoiceFormDesktop from './invoiceForm/invoiceFormDesktop.component'
import InvoiceFormMobile from './invoiceForm/invoiceFormMobile.component'

export const invoiceRowDefaultValues = {
  description: '',
  invoice_expense_id: -1,
  invoice_allowance_id: -1,
  start_date: new Date(),
  end_date: new Date(),
  quantity: '',
  unit: 'kpl',
  quantity_price: '',
  vat_percent: 25.5,
  sum_tax_free: '0',
  sum_with_vat: '0'
}

const groupInvoiceRowValue = {
  groupEmail: '',
  groupAmount: ''
}

let _date = new Date()
let _dateDue = new Date().setDate(_date.getDate() + 14)

export const defaultValues = {
  description: '',
  invoice_reference: '',
  billing_date: _date,
  due_date: _dateDue,
  overdue: 14,
  quick_pay: false,
  invoice_reminder: false,
  status: 0,
  country: '1',
  company_name: '',
  customer_type: 'company',
  business_id: '',
  VAT_id: '',
  person_to_contact: '',
  person_to_contact_email: '',
  person_to_quick_pay_email: '',
  delivery_address: '',
  zip_code: '',
  city: '',
  web_invoice: '',
  delivery_method: 'Sähköposti',
  finvoice_operator: '',
  invoice_price_selection: false,
  invoice_lang: false,
  sum: 0,
  total_sum: 0,
  rows: [invoiceRowDefaultValues],
  customer_id: '',
  is_credit_note: false,
  groupInvoiceRow: [groupInvoiceRowValue, groupInvoiceRowValue],
  groupTotalAmount: 0,
  groupRemainAmount: 0,
  groupInvoice: false,
  vat_selection: 25.5,
  addCost: false,
  addAllowance: false,
  attachments: [],
  addWorkshiftJournal: false
}

const InvoiceNewComponent = () => {
  const { t } = useTranslation()
  const isEdit = useSelector((state) => state.invoice.isEdit)

  const [step, setStep] = useState(1)
  const totalSteps = mobileView ? 7 : 5
  const [formValues, setFormValues] = useState(defaultValues)

  const updateFormValues = (newValues) => {
    setFormValues((prevValues) => {
      const updatedValues = { ...prevValues, ...newValues }

      // Loop over the keys in the previous form values to check if any field is missing in newValues
      Object.keys(prevValues).forEach((key) => {
        // If the key is not in newValues and the previous value was filled, reset it to the default
        if (!(key in newValues) && prevValues[key]) {
          updatedValues[key] = defaultValues[key] || ''
        }
      })

      return updatedValues
    })
  }

  const goBack = (newValues) => {
    if (step > 1) {
      setStep(step - 1)
    }
    updateFormValues(newValues)
  }

  const goNext = (newValues) => {
    if (step < totalSteps) {
      setStep(step + 1)
    }
    updateFormValues(newValues)
  }

  useEffect(() => {
    const shouldShowFinalStep = sessionStorage.getItem(
      'reopenInvoiceModalWithFinalStep'
    )
    if (shouldShowFinalStep) {
      setStep(totalSteps)
      sessionStorage.removeItem('reopenInvoiceModalWithFinalStep')
    }
  }, [])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        height: '100%'
      }}
    >
      <h3
        style={{
          paddingBottom: 0,
          fontWeight: '600',
          textAlign: 'center',
          textTransform: 'none'
        }}
      >
        {isEdit ? t('invoice.header') : t('invoice.header2')}
      </h3>

      <MultiStepProgress step={step} totalSteps={totalSteps} />

      {mobileView ? (
        <InvoiceFormMobile
          step={step}
          goBack={goBack}
          goNext={goNext}
          formValues={formValues}
          updateFormValues={updateFormValues}
        />
      ) : (
        <InvoiceFormDesktop
          step={step}
          goBack={goBack}
          goNext={goNext}
          formValues={formValues}
          updateFormValues={updateFormValues}
        />
      )}
    </div>
  )
}

export default InvoiceNewComponent
